import React from "react";
import { Drawer, Descriptions, Typography, Tag, Space, Empty } from "antd";
import {
  EnvironmentOutlined,
  CalendarOutlined,
  BookOutlined,
} from "@ant-design/icons";
import PersonChip from "./PersonChip";

const { Title, Paragraph, Text } = Typography;

// Side panel showing a case's clinical information.
const ClinicalDrawer = ({ open, onClose, caseData }) => {
  if (!caseData) return null;

  const region = [caseData.organ, caseData.region].filter(Boolean).join(" › ");

  return (
    <Drawer
      title="Informations cliniques"
      placement="right"
      open={open}
      onClose={onClose}
      width={400}
      mask={false}
      styles={{ body: { padding: 16 } }}
    >
      <Title level={4} style={{ marginTop: 0, marginBottom: 8 }}>
        {caseData.pathology}
      </Title>
      {region && (
        <Space wrap size={[4, 8]} style={{ marginBottom: 16 }}>
          <Tag icon={<EnvironmentOutlined />}>{region}</Tag>
        </Space>
      )}

      <Descriptions
        size="small"
        column={1}
        colon={false}
        labelStyle={{ width: 120, color: "var(--color-text-secondary)" }}
        style={{ marginBottom: 16 }}
      >
        {caseData.courseName && (
          <Descriptions.Item label={<Space size={6}><BookOutlined />Cours</Space>}>
            {caseData.courseName}
          </Descriptions.Item>
        )}
        {caseData.date && (
          <Descriptions.Item label={<Space size={6}><CalendarOutlined />Date</Space>}>
            {caseData.date}
          </Descriptions.Item>
        )}
        {caseData.owner && (
          <Descriptions.Item label="Propriétaire">
            <PersonChip name={caseData.owner} />
          </Descriptions.Item>
        )}
      </Descriptions>

      <Title level={5} style={{ marginBottom: 8 }}>
        Résumé clinique
      </Title>
      {caseData.clinicalSummary ? (
        <Paragraph style={{ whiteSpace: "pre-wrap", marginBottom: 0 }}>
          {caseData.clinicalSummary}
        </Paragraph>
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <Text type="secondary">Aucun résumé clinique fourni.</Text>
          }
        />
      )}
    </Drawer>
  );
};

export default ClinicalDrawer;
